import React, { memo, useContext, useMemo } from 'react';
import {
  ImageViewerContext,
  LocalizationContext,
  OrdersContext,
} from 'contexts';
import {
  Caption,
  Icon,
  Text,
  Button,
  Actions,
  Grid,
  GridItem,
  FormInput,
} from '@sdflc/ui';

import { BUTTONS_WITH_NAMES, colors } from 'config';
import { InputCurrency } from 'components/Controls';
import { getOrderStepPagePreRequisites } from './ordersHelpers';

const OrderComplete = memo(() => {
  const { getText } = useContext(LocalizationContext);
  const { setViewImageIdx } = useContext(ImageViewerContext);
  const {
    orderHooks,
    orderItemHooks,
    orderReceiptHooks,
    handleClickAction,
    isLoading,
  } = useContext(OrdersContext);
  const { order } = orderHooks;
  const { orderItems } = orderItemHooks;
  const { orderReceipts } = orderReceiptHooks;

  const { orderDetails, labelData, hintData } = useMemo(() => {
    return getOrderStepPagePreRequisites({
      order,
      orderItems,
      getText,
      stepName: 'orderComplete',
    });
  }, [order, orderItems, getText]);

  if (isLoading) {
    return null;
  }

  return (
    <Grid>
      <GridItem width={['100%', '100%', '100%', '80%', '80%']}>
        <Caption level={3}>
          <Icon name='CheckBox' iconSize={64} color={colors.darkBlue} pr={2} />
          {getText('blocks.orderComplete.header', order)}
        </Caption>
        <Caption level={4}>
          <Text>{getText('blocks.orderComplete.title', order)}</Text>
        </Caption>
      </GridItem>
      <GridItem width={['100%', '100%', '100%', '20%', '20%']}>
        <Actions
          actions={[BUTTONS_WITH_NAMES.GO_TO_ORDER_VIEW]}
          onClick={handleClickAction}
          dimension={Button.DIMENSION_NAMES.MEDIUM}
        />
      </GridItem>
      <GridItem width={['100%', '100%', '100%', '100%', '100%']}>
        <Text mt={3}>{getText(`blocks.orderComplete.subtitle`, order)}</Text>
      </GridItem>
      <GridItem width={['100%', '100%', '100%', '50%', '50%']}>
        <FormInput
          labelData={labelData}
          hintData={hintData}
          data={orderDetails}
          fieldName='orderItemsQty'
          readOnly
          leftIcon='FormatListNumbered'
        />
      </GridItem>
      <GridItem width={['100%', '100%', '100%', '50%', '50%']}>
        <FormInput
          labelData={labelData}
          hintData={hintData}
          data={orderDetails}
          fieldName='orderItemsTakenQty'
          readOnly
          leftIcon='FormatListNumbered'
        />
      </GridItem>
      <GridItem width={['100%', '100%', '100%', '50%', '50%']}>
        <FormInput
          labelData={labelData}
          hintData={hintData}
          data={orderDetails}
          fieldName='orderAmount'
          inputComponent={InputCurrency}
          readOnly
          currencyCode={orderDetails.currency}
          buttonName={
            orderReceipts.length ? getText('buttons.viewReceipts') : undefined
          }
          onClick={
            orderReceipts.length
              ? () => {
                  setViewImageIdx(0);
                }
              : undefined
          }
        />
      </GridItem>
    </Grid>
  );
});

OrderComplete.displayName = 'OrderComplete';

export { OrderComplete };
